import type { HeroSlide, CategoryShortcut } from "@/types";

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-1",
    title: "白羽雪乃 · 星霜少女",
    subtitle: "年度人气冠军角色",
    desc: "银发如雪，沉默却温柔。她用一个冬天的坚持，教会我们温柔也是一种力量。",
    image: "https://readdy.ai/api/search-image?query=dreamy%20anime%20hero%20banner%20of%20silver%20haired%20girl%20in%20snowy%20fantasy%20landscape%2C%20soft%20pink%20and%20lavender%20pastel%20palette%2C%20cinematic%20anime%20illustration%2C%20high%20detail&width=1600&height=900&seq=hero-slide-01&orientation=landscape",
    link: "/role/shirayuki-yukino",
    badge: "人气推荐"
  },
  {
    id: "slide-2",
    title: "森之魔法语 · 新篇上线",
    subtitle: "年度治愈天花板",
    desc: "见习魔女桃濑小铃，用一次次失败的咒语，把整片森林都变成了家。",
    image: "https://readdy.ai/api/search-image?query=magical%20enchanted%20forest%20anime%20banner%20with%20pink%20haired%20witch%20girl%2C%20sparkling%20pastel%20green%20and%20pink%20palette%2C%20cinematic%20anime%20illustration%2C%20high%20detail&width=1600&height=900&seq=hero-slide-02&orientation=landscape",
    link: "/news/forest-magic-review",
    badge: "最新资讯"
  },
  {
    id: "slide-3",
    title: "月下铃兰 · 东方美学",
    subtitle: "每一帧都是壁纸",
    desc: "满月之夜，月见铃兰的舞步能让枯萎的铃兰重新绽放。",
    image: "https://readdy.ai/api/search-image?query=moonlit%20traditional%20anime%20banner%20with%20lavender%20haired%20girl%20dancing%2C%20dreamy%20purple%20and%20silver%20pastel%20palette%2C%20cinematic%20anime%20illustration%2C%20high%20detail&width=1600&height=900&seq=hero-slide-03&orientation=landscape",
    link: "/role/tsukimi-suzuran",
    badge: "专题精选"
  }
];

export const categoryShortcuts: CategoryShortcut[] = [
  {
    id: "moe",
    name: "萌系",
    desc: "软软糯糯，一眼心动",
    icon: "ri-heart-3-line",
    count: 128
  },
  {
    id: "cool",
    name: "冷系",
    desc: "清冷孤高，自带气场",
    icon: "ri-snowflake-line",
    count: 96
  },
  {
    id: "genki",
    name: "元气",
    desc: "热血满格，永远向前",
    icon: "ri-fire-line",
    count: 114
  },
  {
    id: "healing",
    name: "治愈",
    desc: "温柔安定，抚平情绪",
    icon: "ri-plant-line",
    count: 87
  },
  {
    id: "elegant",
    name: "优雅",
    desc: "举手投足，皆是风情",
    icon: "ri-moon-line",
    count: 63
  },
  {
    id: "tsundere",
    name: "傲娇",
    desc: "口是心非，越看越上头",
    icon: "ri-emotion-happy-line",
    count: 72
  }
];

export const siteInfo = {
  brand: "萝莉",
  fullName: "萝莉动漫主题站",
  slogan: "专注二次元萝莉形象与文化的聚合平台",
  intro:
    "萝莉动漫主题站是一个专注于二次元萝莉动漫形象及文化资讯聚合与深度展示的内容平台。我们围绕角色介绍、动画资讯与文化专题三大核心方向，服务于广大二次元动漫爱好者，尤其关注萝莉文化粉丝对角色资料、文化探讨与信息获取的深度需求。",
  mission:
    "我们致力于打造专业、丰富、有温度的萝莉动漫主题内容平台，用严谨的态度整理每一份角色资料，用细腻的视角解读每一部作品，让每一位热爱二次元文化的人，都能在这里找到属于自己的那一份共鸣。",
  email: "hello@lolianime.example.com",
  weibo: "萝莉动漫主题站",
  bilibili: "萝莉动漫主题站",
  qq: "萝莉动漫交流群 123456789",
  address: "中国 · 上海市 · 二次元创意产业园 B 座"
};

export const teamMembers = [
  {
    name: "林川",
    role: "内容主编",
    desc: "十年二次元内容从业者，坚信好内容值得被认真对待。",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20style%20avatar%20portrait%20of%20editor%20character%2C%20soft%20pink%20background%2C%20kawaii%20illustration%2C%20clean%20minimal&width=300&height=300&seq=team-01&orientation=squarish"
  },
  {
    name: "青羽",
    role: "专题策划",
    desc: "负责世界观深度解析，喜欢把细节讲成故事。",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20style%20avatar%20portrait%20of%20creative%20planner%20character%2C%20soft%20lavender%20background%2C%20kawaii%20illustration%2C%20clean%20minimal&width=300&height=300&seq=team-02&orientation=squarish"
  },
  {
    name: "小葵",
    role: "资讯编辑",
    desc: "追番速度永远最快，第一时间把最新消息带给你。",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20style%20avatar%20portrait%20of%20news%20editor%20character%2C%20soft%20peach%20background%2C%20kawaii%20illustration%2C%20clean%20minimal&width=300&height=300&seq=team-03&orientation=squarish"
  },
  {
    name: "夜行猫",
    role: "社区运营",
    desc: "社区里最活跃的那一个，负责让大家聊得开心。",
    avatar: "https://readdy.ai/api/search-image?query=cute%20pastel%20anime%20style%20avatar%20portrait%20of%20community%20manager%20character%2C%20soft%20blue%20background%2C%20kawaii%20illustration%2C%20clean%20minimal&width=300&height=300&seq=team-04&orientation=squarish"
  }
];